export default function getAllPropertyNames(arr) {
  if (arr.length === 0) return [];

  return arr
    .map((obj) => Object.keys(obj))
    .reduce((common, keys) => common.filter((key) => keys.includes(key)));
}
